/**
 * The body rect dive/pop math anchors on — PURE scene geometry.
 *
 * This replaced a `getBoundingClientRect` walk over the widget's
 * `[part="subspace"]` DOM. The DOM slot is a flex placeholder whose layout
 * box can overflow the card (a described container's column row is as tall
 * as its unclipped text — measured at ~1.9× the card height), so anchoring
 * a dive on it framed the nested space against a rect that exists nowhere
 * on screen: the "snaps to the old fit" / "stretches at some zoom" class.
 * `subspaceSlotRect` is the SAME solver rect the nested preview renders at
 * (`NestedSpaceFit`) and the SVG export projects into, so dive, pop, render
 * and export agree by construction — and it needs no mounted DOM, so a dive
 * from any zoom (collapsed band included) anchors correctly.
 */
import { subspaceSlotRect, type BoardItem } from "@archlang/scene/board";
import type { ItemLocalRect } from "@archlang/scene/board";

export function diveBodyRect(item: BoardItem): ItemLocalRect {
  return subspaceSlotRect(item);
}
